// initial state
const initialState = {
    modalState: false,
    deleteModalState: true
}

// type
const CHANGE_MODAL_STATUS = 'CHANGE_MODAL_STATUS',
      DELETE_MODAL_STATUS = 'DELETE_MODAL_STATUS';

// reducer
const modalReducer = (state=initialState, action) => {
    switch(action.type){
        case 'CHANGE_MODAL_STATUS': return {
            modalState: action.payload
        }
        case 'DELETE_MODAL_STATUS': return {
            deleteModalState: action.payload
        }
        default: return state;
    }
}

// action
const modalAction = () => async ( dispatch, getState ) => {
    dispatch({
        type: CHANGE_MODAL_STATUS,
        payload: !getState().Modal.modalState
    });
}

const modalDeleteAction = () => async ( dispatch, getState ) => {
    dispatch({
        type: DELETE_MODAL_STATUS,
        payload: !getState().Modal.deleteModalState
    });
}

// export
export { modalAction, modalDeleteAction }

export default modalReducer;
